import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/paperGirl.png'


const _hoisted_1 = { class: "container reserved-document" }
const _hoisted_2 = {
  class: "alert alert-dismissible alert-success mb-1",
  role: "alert"
}
const _hoisted_3 = { class: "alert__icon" }
const _hoisted_4 = { class: "alert__content" }
const _hoisted_5 = {
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "alert",
  "aria-label": "Fechar"
}
const _hoisted_6 = { class: "text-start d-flex mt-4 justify-content-between" }
const _hoisted_7 = { class: "card-left col-md-7 col-12 print-section" }
const _hoisted_8 = { class: "info-box" }
const _hoisted_9 = { class: "d-flex justify-content-end" }
const _hoisted_10 = { class: "d-flex justify-content-end btn-imprimir" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_DocumentToPrint = _resolveComponent("DocumentToPrint")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "breadcrumb-password-view py-3 row" }, null, -1)),
      _createVNode(_component_Breadcrumb, { "path-list": { 'Emissão de Certificado': '#', BirdId: '#' } }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Icon, { name: "shield" })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text" }, " Parabéns! Sua solicitação foi aprovada com sucesso! Verifique seu e-mail. ", -1)),
          _createElementVNode("button", _hoisted_5, [
            _createVNode(_component_Icon, {
              name: "xmark",
              class: "mt-2"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-center fw-600" }, "DOCUMENTO RESERVADO", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "divisor" }, null, -1)),
          _cache[8] || (_cache[8] = _createElementVNode("div", null, "Dados para emitir Certificado Digital após aprovação", -1)),
          _createElementVNode("div", null, [
            _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Código da solicitação: ", -1)),
            _createTextVNode(_toDisplayString(_ctx.form.codigoSolicitacao), 1)
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "divisor" }, null, -1)),
          _cache[10] || (_cache[10] = _createElementVNode("div", null, " Após aprovação da sua Solicitação, utilize os dados informados abaixo para fazer a instalação do Certificado Digital. ", -1)),
          _createElementVNode("div", _hoisted_8, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "fw-600" }, "Usuário: ", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.form.user), 1)
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "info-box" }, [
            _createElementVNode("span", { class: "fw-600" }, "Senha: "),
            _createTextVNode(" criada pelo usuário ")
          ], -1)),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_RouterLink, {
              to: `/${_ctx.form.arData.subdomain}/guia-de-instalacao-de-certificado-digital`,
              class: "btn btn-primary btn-sm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, { name: "shield" }),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ms-2" }, "Instalar Certificado", -1))
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "divisor" }, null, -1)),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "fw-600" }, "Atenção", -1)),
          _cache[14] || (_cache[14] = _createElementVNode("div", null, [
            _createElementVNode("span", { class: "fw-600" }, "Para sua segurança"),
            _createTextVNode(", guarde este documento em local seguro até que emita seu Certificado Digital Soluti. ")
          ], -1)),
          _cache[15] || (_cache[15] = _createElementVNode("div", null, " Após a emissão, esses dados não serão mais necessários e este documento poderá ser descartado. ", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "btn btn-outline-primary btn-sm",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imprimir && _ctx.imprimir(...args)))
            }, [
              _createVNode(_component_Icon, { name: "print" }),
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ms-2" }, "Imprimir", -1))
            ])
          ])
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-md-4 d-none d-md-block" }, [
          _createElementVNode("img", {
            class: "ms-4 card-right-img",
            src: _imports_0,
            alt: "Desenho de uma menina com um folha de papel atrás."
          })
        ], -1))
      ]),
      _createVNode(_component_Contact)
    ]),
    _createVNode(_component_DocumentToPrint, { class: "document-to-print" })
  ], 64))
}